import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-privacy-policy-popup',
  templateUrl: './privacy-policy-popup.component.html',
  styleUrls: ['./privacy-policy-popup.component.scss'],
})
export class PrivacyPolicyPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  @Input() data: any;
  constructor(public readonly modal: NgbActiveModal) {
    super();
  }

  public ngOnInit(): void {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
}
